module.exports = __webpack_public_path__ + "static/magic-card-56edbdde63b0a24d3e10c3b2138e5e68.jpg";